import { MIN_PAINTER_SIZE } from '../config'

export class PainterModel {
  constructor(
    public coordinates: [number, number],
    public radius: number = MIN_PAINTER_SIZE
  ) {}
}
